import axios from "axios";

export const COMPANY_KEY = "f360_company";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export const linkParam = (params, key = "token") => new URLSearchParams(window.location.hash.slice(1)).get(key) || params.get(key) || "";

api.interceptors.request.use((cfg) => {
  const company = localStorage.getItem(COMPANY_KEY);
  if (company) {
    cfg.headers["X-Company-Id"] = company;
  }
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    const skip = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/register-company"].some((u) => url.includes(u));
    if (error.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message === "Network Error" ? "Erreur réseau, vérifiez votre connexion." : "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
